var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 148,
    height: 148,
    viewBox: "0 0 148 148",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.7959 1V27.5306M1 54.0612L146.918 54.0612M107.122 1V27.5306M67.3265 87.2245H107.122M67.3265 113.755H107.122M40.7959 87.2245H40.8622M40.7959 113.755H40.8622M14.2653 146.918H133.653C140.979 146.918 146.918 140.979 146.918 133.653V27.5306C146.918 20.2044 140.979 14.2653 133.653 14.2653H14.2653C6.93908 14.2653 1 20.2044 1 27.5306V133.653C1 140.979 6.93908 146.918 14.2653 146.918Z",
    stroke: "#081754",
    strokeWidth: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.3782560cedb48d2b2ccfa1bb297bd89d.svg";
export { ForwardRef as ReactComponent };